module.exports = __webpack_public_path__ + "assets/img/zhencha-70489cd5.png";